import type { PrizeListItem } from '../hooks/usePrizesListView'

export const selectFeaturedPrize = (
  items: PrizeListItem[]
): PrizeListItem | null => items.find(item => item.featured) ?? null
